import { create } from 'zustand'
import { devtools } from 'zustand/middleware'

import { RefreshFirstReceiptStatusClientResponse } from '../@types/refreshFirstReceiptStatus'

type Store = {
  refreshFirstReceiptStatus: RefreshFirstReceiptStatusClientResponse | null
  setRefreshFirstReceiptStatus: (
    value: RefreshFirstReceiptStatusClientResponse,
  ) => void
}

export const useRefreshFirstReceiptStatusStore = create<Store>()(
  devtools(
    (set) => ({
      refreshFirstReceiptStatus: null,
      setRefreshFirstReceiptStatus: (refreshFirstReceiptStatus) =>
        set({ refreshFirstReceiptStatus }),
    }),
    { name: 'RefreshFirstReceiptStatusStore' },
  ),
)
